import { EmployeeProfileRoleDto } from '@/api/generated';
import { employeeProfileChatFastQuestionsManagerTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/fastQuestions/manager/employeeProfile.chat.fastQuestions.manager.translation.en.ts';
import { employeeProfileChatFastQuestionsOwnerTranslation } from '@/assets/locales/views/employeeProfile/sections/chat/fastQuestions/owner/employeeProfile.chat.fastQuestions.owner.translation.en.ts';
import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfileChatFormSectionTranslation = SectionTranslationModel<{
  askHim: string;
  defaultTexts: Record<EmployeeProfileRoleDto, DefaultTextsTranslation>;
  form: {
    enterMessage: string;
    fastQuestions: string;
    streamingError: string;
  };
  noMessages: string;
  questionsPerRole: Record<EmployeeProfileRoleDto, FastQuestionTranslation>;
}>;

export type FastQuestionTranslation = {
  fastQuestionButtons: FastQuestion;
  fastQuestionTexts: FastQuestion;
};

export type QuestionKey = `question${number}`;

type DefaultTextsTranslation = {
  description: string;
  headerTitle: string;
  welcomeMessage: string;
};

type FastQuestion = {
  [K in QuestionKey]: string;
};

export const employeeProfileChatFormSectionTranslation: EmployeeProfileChatFormSectionTranslation =
  {
    content: {
      askHim: 'Ask him about his skills, experience, or anything else you want to know.',
      defaultTexts: {
        [EmployeeProfileRoleDto.Admin]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.AdminCertification]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.AdminDevelopment]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.AdminSuccession]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.ForceAccess]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.HqHrbp]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.Hrbp]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.NoAccess]: {
          description: '',
          headerTitle: '',
          welcomeMessage: '',
        },
        [EmployeeProfileRoleDto.Owner]: {
          description:
            'Get personalized guidance for your professional development and career growth',
          headerTitle: 'Your chat',
          welcomeMessage:
            "Hi! I'm here to help you with your professional development and career growth. What would you like to explore today?",
        },
        [EmployeeProfileRoleDto.P1]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
        [EmployeeProfileRoleDto.P2]: {
          description: 'Learn more about your employee and his skills.',
          headerTitle: 'Chat about employee',
          welcomeMessage:
            'Ask me custom questions about this employee or choose from the most common ones below.',
        },
      },
      form: {
        enterMessage: 'Write a message and press enter',
        fastQuestions: 'Fast questions',
        streamingError: 'An error occurred, please try again later',
      },
      noMessages: 'Start a conversation with the virtual assistant about chosen employee.',
      questionsPerRole: {
        [EmployeeProfileRoleDto.Admin]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.AdminCertification]:
          employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.AdminDevelopment]:
          employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.AdminSuccession]:
          employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.ForceAccess]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.HqHrbp]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.Hrbp]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.NoAccess]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.Owner]: employeeProfileChatFastQuestionsOwnerTranslation,
        [EmployeeProfileRoleDto.P1]: employeeProfileChatFastQuestionsManagerTranslation,
        [EmployeeProfileRoleDto.P2]: employeeProfileChatFastQuestionsManagerTranslation,
      },
    },
    headerTitle: 'Chat',
    headerTitleShorter: 'Chat',
  };
